
export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const SET_TIME_RANGE = "SET_TIME_RANGE";
export const AUTO_UPDATE_DATE = "AUTO_UPDATE_DATE";

export const setDateRange = ({ startDate, endDate }) => {
  const payload = { startDate, endDate }; 
  localStorage.setItem('dateRange', JSON.stringify(payload));

  return {
    type: SET_DATE_RANGE,
    payload,
  };
};


export const setTimeRange = (startTime, endTime) => ({
  type: SET_TIME_RANGE,
  payload: { startTime, endTime },
});

export const autoUpdateDate = () => ({
  type: AUTO_UPDATE_DATE,
});

